import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * Exception indicating there exists data integrity violations on client's request and thus cannot be futher processed.
 * HTTP Response Status Code 510
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class DataCorruptionError extends MfsFolderError {
    constructor(message, eventName) {
        super(message !== null && message !== void 0 ? message : `Data corruption exception`, false, eventName !== null && eventName !== void 0 ? eventName : 'DataCorruption', MfsStatusCode.DataCorruption);
    }
}
//# sourceMappingURL=dataCorruptionError.js.map